import { Route, Routes } from 'react-router-dom';
import Home from './Home';
import { Accounts } from './components/account/Accounts';
import { Customers } from './components/customer/Customers';
import { Tms } from './components/tms/Tms';
import { AccountIdContextProvider } from './components/account/AccountIdContext';
import Debug from './Debug';

export default function StratusRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/debug" element={<Debug />} />
      <Route path="/customers/*" element={<Customers />} />

      <Route
        path="/accounts/*"
        element={
          <AccountIdContextProvider>
            <Accounts />
          </AccountIdContextProvider>
        }
      />
      <Route path={'/tms/*'} element={<Tms />} />
    </Routes>
  );
}
